const ToggleMembershipCard = () => {

	return (<div className="ft-tr ">
		<div className="ft-th">{" "}</div>
		<div className="ft-td text-left">
			<button type="button" className="btn btn-sm btn-primary mt-md-2" data-toggle="modal"
			        data-target="#membershipCardModal">
				Visa medlemskort
			</button>
		</div>
	</div>)

}

export default ToggleMembershipCard;